import { useIntl } from "react-intl";
import useDarkMode from "../../../../hooks/useDarkMode";

const NoneHistory = () => {
    const intl = useIntl();
    const isDarkMode = useDarkMode();

    return (

        <div className="flex-1-1" style={{ background: isDarkMode ? '#262626' : '#F9FAFB', height: 60, display: 'flex', alignItems: 'center', gap: 10, padding: 10, borderRadius: 5 }}>
            <div>
                <span className="rioglyph rioglyph-time-alt text-size-20"></span>
            </div>
            <div className="flex flex-column">
                <span className="text-medium text-size-14">
                    {intl.formatMessage({
                        id: "intl-msg:maintenanceGroup.history.empty.title",
                    })}
                </span>

                <span className="text-normal text-size-14">
                    {intl.formatMessage({
                        id: "intl-msg:maintenanceGroup.history.empty.description",
                    })}
                </span>
            </div>
        </div>
    )
}

export default NoneHistory;